<template>
  <div>
    <transition name="slide-fade-up">
      <b-img
        :src="require('@/assets/images/logo_centered.svg')"
        width="300"
        class="rounded-0"
      />
    </transition>

    <div class="mt-5">
      <h2 class="font-weight-bold">You have been Invited!</h2>
    </div>

    <b-form class="mt-4" @submit.prevent="onSubmit">
      <b-button type="submit" variant="primary" block>
        <b-spinner class="mr-2" small v-if="isLoading" /> Accept Invitation
      </b-button>
    </b-form>

    <p class="mt-1">
      By accepting invitation, you will be redirected to the next step.
    </p>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'

export default {
  methods: {
    async onSubmit() {
      const form = new FormData()
      form.append('token', this.$route.query.token)
      const { data } = await this.$store.dispatch('auth/acceptInvitation', form)
      this.$router.push({
        name: data.isUserExist ? 'auth.login-page' : 'auth.register-page',
        query: { email: data.email }
      })
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.auth.isLoading
    })
  },

  async beforeRouteEnter(to, from, next) {
    if (!to.query.token) {
      next('login')
      return
    }
    const form = new FormData()
    form.append('token', to.query.token)
    try {
      await store.dispatch('auth/checkInvitationToken', form)
      next()
    } catch (e) {
      next('/login')
    }
  },

  mounted() {
    this.show = true
  }
}
</script>

<style lang="scss" scoped>
.form-link {
  font-weight: bold;
}
.encryptable {
  right: 8px;
}
</style>
